import {
  FormCancelButton,
  PreviewableModal,
  StyledModal,
} from 'common/components';
import { useCertificateColumns } from 'pages/company-profile/components/tabs/contacts/companyCertificate/hook';
import { EmptyView } from 'pages/company-profile/components/tabs/contacts/companyContact/AssociateLocationsModal';
import { useContactColumns } from 'pages/company-profile/components/tabs/contacts/companyContact/hook';
import {
  FileTextTwoTone,
  IdcardTwoTone,
} from '@ant-design/icons';

import { LOCATION_COLUMNS_AG } from 'pages/company-profile/components/tabs/contacts/companyLocation/constants';
import CustomTable from 'pages/company-profile/components/tabs/contacts/components/CustomTable';
import { useState } from 'react';

export const useGetLocationColumnsDef = () => {
  const columnsDefs = [
    {
      field: '',
      checkboxSelection: true,
      filter: false,
      suppressMenu: true,
      width: 50,
      resizable: true,
    },
    ...LOCATION_COLUMNS_AG,
    {
      dataType: 'string',
      headerName: 'Associated Contacts',
      fieldName: 'associateContactIds',
      fieldNameCamelCase: 'associateContactIds',
      allowFilter: true,
      allowSort: true,
      width: 180,
      cellRenderer: ({ data }) => {
        return (
          <RenderAssociated data={data} typeView={ASSOCIATE_TYPE.contact} />
        );
      },
      resizable: true,
    },
    {
      dataType: 'string',
      headerName: 'Associated Certificates',
      fieldName: 'associateCertificateIds',
      fieldNameCamelCase: 'associateCertificateIds',
      allowFilter: true,
      allowSort: true,
      width: 200,
      cellRenderer: ({ data }) => {
        return (
          <RenderAssociated data={data} typeView={ASSOCIATE_TYPE.certificate} />
        );
      },
      resizable: true,
    },
  ];

  return { columnsDefs };
};

const ASSOCIATE_TYPE = {
  contact: 'contact',
  certificate: 'certificate',
};

export const RenderAssociated = (props) => {
  const { data, typeView } = props;
  const [visible, setVisible] = useState(false);

  const { associateCertificates, associateContacts } = data;

  const associatedData = {
    [ASSOCIATE_TYPE.contact]: {
      dataSource: associateContacts,
      Icon: IdcardTwoTone,
    },
    [ASSOCIATE_TYPE.certificate]: {
      dataSource: associateCertificates,
      Icon: FileTextTwoTone,
    },
  };

  const Icon = associatedData[typeView].Icon;

  return (
    <>
      {associatedData[typeView].dataSource.length > 0 ? (
        <Icon
          style={{ fontSize: 16, cursor: 'pointer' }}
          onClick={() => {
            setVisible(true);
          }}
        />
      ) : (
        ''
      )}
      {visible && (
        <AssociatedModal
          data={data}
          visible={visible}
          typeView={typeView}
          setVisible={setVisible}
        />
      )}
    </>
  );
};

const AssociatedModal = (props) => {
  const { data, typeView, visible, setVisible } = props;
  const [stateActions, setStateActions] = useState({
    visible: false,
    data: null,
  });

  const { associateCertificates, associateContacts } = data;

  const { columns: certificateColumns } = useCertificateColumns(
    [],
    setStateActions
  );

  const { columns: contactColumns } = useContactColumns();

  const associatedData = {
    [ASSOCIATE_TYPE.contact]: {
      columns: contactColumns,
      dataSource: associateContacts,
      title: 'Associated Contacts',
      Icon: IdcardTwoTone,
    },
    [ASSOCIATE_TYPE.certificate]: {
      columns: certificateColumns,
      dataSource: associateCertificates,
      title: 'Associated Certificate',
      Icon: FileTextTwoTone,
    },
  };

  const { data: dataPreview } = stateActions;

  return (
    <>
      <StyledModal
        key={typeView}
        title={associatedData[typeView].title}
        width={1150}
        destroyOnClose
        maskClosable={false}
        visible={visible}
        onCancel={() => setVisible(false)}
        bodyStyle={{ height: 'min(500px, 50vh)' }}
        footer={[<FormCancelButton onClick={() => setVisible(false)} />]}
      >
        {associatedData[typeView].dataSource?.length > 0 ? (
          <div style={{ height: 430 }}>
            <CustomTable
              columns={associatedData[typeView].columns}
              dataSource={associatedData[typeView].dataSource}
              rowSelection={null}
            />
          </div>
        ) : (
          <EmptyView text={`No ${typeView} available to link`} />
        )}
      </StyledModal>

      {stateActions.visible && (
        <PreviewableModal
          id={dataPreview?.id}
          link={dataPreview?.url}
          title={dataPreview?.certificateName}
          visible={stateActions.visible}
          fileName={dataPreview?.certificateName}
          cancelModal={() => setStateActions({ visible: false, data: null })}
          isDownload={false}
          fileType={dataPreview?.fileType}
          assetData={dataPreview}
          isDocument={true}
        />
      )}
    </>
  );
};
